import React from 'react';
import fachadaMuseu from '../../assets/fotofrenteoverlay.png';

const PlanVisitSection = () => {
  const visitOptions = [
    { title: 'Dias disponíveis para visita', link: '#location', colorClass: 'teal' },
    { title: 'Acessar o acervo virtual', link: '#acervo', colorClass: 'mauve' },
    { title: 'Sobre o museu', link: '#about', colorClass: 'teal' },
    { title: 'Como chegar', link: '#location', colorClass: 'mauve' },
  ];

  return (
    <section className="plan-visit-section" id="plan-visit-section">
      <div className="container">
        <h2 className="section-title-planVisit">Planeje a sua visita</h2>

        <div className="plan-visit-grid">
          {/* Lado esquerdo */}
          <div className="visit-links align-right">
            {visitOptions.slice(0, 2).map((option, index) => (
              <a
                key={index}
                href={option.link}
                className={`visit-link ${option.colorClass} delay-${index}`}
              >
                {option.title}
              </a>
            ))}
          </div>

          {/* Imagem central */}
          <div className="center-image-wrapper">
            <div className="image-tilted">
              <img src={fachadaMuseu} alt="Fachada do Museu" />
            </div>
          </div>

          {/* Lado direito */}
          <div className="visit-links align-left">
            {visitOptions.slice(2).map((option, index) => (
              <a
                key={index}
                href={option.link}
                className={`visit-link ${option.colorClass} delay-${index + 2}`}
              >
                {option.title}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlanVisitSection;
